import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class BaseService {

    static toBase64(data: string | number): string {
        try {
          return btoa(String(data));
        } catch (error) {
          return '';
        }
      }
      static fromBase64(base64String: string): string {
        try {
           return atob(base64String);
        } catch (error) {
          return '';
        }
      }
}